"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _ProductSubmitForm = _interopRequireDefault(require("../ProductSubmitForm/ProductSubmitForm"));

var _product = require("../../store/product/product.actions");

var _product2 = require("../../store/product/product.selectors");

var _gift = require("../../store/gift/gift.selector");

var _productDetails = _interopRequireDefault(require("./productDetails.styles"));

var ProductDetails = function ProductDetails(_ref) {
  var isOpen = _ref.isOpen,
      product = _ref.product,
      optionsData = _ref.optionsData,
      onClose = _ref.onClose,
      _ref$sidebarProps = _ref.sidebarProps,
      sidebarProps = _ref$sidebarProps === void 0 ? {} : _ref$sidebarProps,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isMerchantSidebar = _useState2[0],
      setIsMerchantSidebar = _useState2[1];

  var classes = (0, _productDetails.default)();
  var isLoading = (0, _reactRedux.useSelector)(_product2.getIsLoading);
  var productDetails = (0, _reactRedux.useSelector)(_product2.getProductDetails);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var handleToggleMerchant = (0, _react.useCallback)(function () {
    setIsMerchantSidebar(function (isMerchantView) {
      return !isMerchantView;
    });
  }, []);
  var handleToggleProductTab = (0, _react.useCallback)(function () {// trackEvent('Product - Clicked tab', { tab });
  }, []);
  var sidebarHeader = (0, _react.useMemo)(function () {
    if (!productDetails) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var headerComponent = isMerchantSidebar ? /*#__PURE__*/_react.default.createElement(_ui.MerchantHeader, {
      title: "Merchant details",
      logo: productDetails === null || productDetails === void 0 ? void 0 : productDetails.provider.logo,
      onBack: handleToggleMerchant
    }) : /*#__PURE__*/_react.default.createElement(_ui.ProductSidebarTitle, {
      title: "Gift details"
    });
    return /*#__PURE__*/_react.default.createElement(_ui.ProductSidebarHeader, {
      onClose: onClose,
      overrideClasses: classes
    }, headerComponent);
  }, [productDetails, isMerchantSidebar, handleToggleMerchant, onClose, classes]);
  (0, _react.useEffect)(function () {
    if (isOpen && product && product !== null && product !== void 0 && product.id) {
      dispatch((0, _product.loadProductDetailsRequest)({
        giftId: giftId,
        productId: product.id
      }));
    } else {
      dispatch((0, _product.resetProductDetails)());
      setIsMerchantSidebar(false);
    }
  }, [isOpen, dispatch, product, giftId]);
  return /*#__PURE__*/_react.default.createElement(_ui.ProductSidebar, (0, _extends2.default)({
    isOpen: isOpen,
    onClose: onClose,
    header: sidebarHeader
  }, sidebarProps), /*#__PURE__*/_react.default.createElement(_ui.AlyceLoading, {
    isLoading: isLoading,
    boxProps: {
      mt: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_ui.ProductDetailsWrapper, {
    hasProduct: !!productDetails
  }, isMerchantSidebar ? /*#__PURE__*/_react.default.createElement(_ui.Merchant, {
    product: productDetails
  }) : /*#__PURE__*/_react.default.createElement(_ui.Product, {
    product: productDetails,
    onShowMerchant: handleToggleMerchant,
    onToggleTab: handleToggleProductTab,
    wrapperProps: {
      mb: 2
    },
    overrideClasses: classes
  }, /*#__PURE__*/_react.default.createElement(_ProductSubmitForm.default, {
    product: productDetails,
    optionsData: optionsData,
    onSubmit: onSubmit
  })))));
};

var _default = ProductDetails;
exports.default = _default;